import { flow, applySnapshot, getSnapshot } from 'mobx-state-tree';
import fpFlow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import uniq from 'lodash/fp/uniq';
import flatten from 'lodash/fp/flatten';
import api from '~/api';
import { toMapById } from '~/mst/utils';
import { IDevicePofilesModel } from './model';

export default (self: IDevicePofilesModel) => ({
  fetch: flow(function* fetch(params: { profile: string }) {
    try {
      self.startFetching();
      const { data } = yield self.sync(api.device_profiles.fetch, params);
      const paths = fpFlow(
        map((profileItem: any) => Object.keys(profileItem.ranges)),
        flatten,
        uniq
      )(data);
      const { data: parameters } = yield self.sync(api.device_profiles.fetchParameters, { paths });
      const fetchedMap = toMapById(data.map((profileItem: any) => ({ ...profileItem, parameters, ...(!profileItem.id && { id: params.profile }) })));
      const currentMap = getSnapshot(self.models);
      applySnapshot(self.models, {
        ...currentMap,
        ...fetchedMap
      });

      self.finishFetching();
    } catch (error) {
      self.failFetching(error);
    }
  })
});
